import { RecordTaskOwnerOptionFragment } from 'types/graphql'

import { TanstackField } from '../../../utils/forms'
import RecordTaskOwnerSelect from '../../Selects/RecordTaskOwnerSelect'

type Props<TKey extends string> = {
  field: TanstackField<RecordTaskOwnerOptionFragment | null | undefined, TKey>
  isRequired?: boolean
  label?: React.ReactNode
  recordTaskId: number
}

const RecordTaskOwnerSelectField = <TKey extends string>({
  field,
  isRequired,
  label,
  recordTaskId,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  return (
    <RecordTaskOwnerSelect
      errorMessage={errorMessage}
      isInvalid={!!errorMessage}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      recordTaskId={recordTaskId}
      value={field.state.value}
    />
  )
}

export default RecordTaskOwnerSelectField
